import { css } from '@terra/ui-styled-system';
import { Cancel01Icon } from '@terra/ui-icons';
import type { MouseEvent } from 'react';

const removeButtonStyles = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  ml: 0.5,
  width: '14px',
  height: '14px',
  borderRadius: '50%',
  border: 'none',
  backgroundColor: 'transparent',
  color: 'terra.11',
  cursor: 'pointer',
  flexShrink: 0,
  padding: 0,
  '&:hover': { backgroundColor: 'terra.a4', color: 'terra.12' },
});

type MentionRemoveButtonProps = {
  label: string;
  onRemove: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function MentionRemoveButton({
  label,
  onRemove,
}: MentionRemoveButtonProps) {
  return (
    <button
      type="button"
      className={removeButtonStyles}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onRemove}
      aria-label={`Remove ${label}`}
    >
      <Cancel01Icon size={10} />
    </button>
  );
}
